import FansHeader from '@/components/fans/header';
import { Footer} from "@/components/common/index.js"
import { FANS } from '@/constant/fans/FANS'
import FansDemandPoolList from '@/components/fans/demand-pool-list';
import DemandPoolListEmpty from '@/components/fans/demand-pool-list-empty';
import {CtPagination} from "@/components/common/index.js"
import {Loading} from '@/components/common'


let mixin = {

  components: {
    FansHeader,
    Footer,
    FansDemandPoolList,
    DemandPoolListEmpty,
    CtPagination,
    Loading
  },

  data(){
    return{
      FANS
    }
  }
}

export default mixin;
